import { useMemo } from "react";
import { HeatingModeEnum } from "./constants";
import { settingsInterface } from "../../../app/recipeCreation/createRecipe.types";

export const getTime = (time: number) => {
    const secs = time % 60;
    const strSecs = secs < 10 ? `0${secs}` : `${secs}`;
    const mins = Math.floor(time / 60);
    return `${mins}:${strSecs}`;
};

export const getTimeObject = (time: number) => {
    const secs = time % 60;
    const mins = Math.floor(time / 60);
    return { mins, secs };
}

export const convertTime = ({ mins, secs }: { mins: number, secs: number }) => {
    return (secs + (mins * 60))
}

export const approxTimeHandlerFunction = (setting: any) => {
    if (setting.time <= 120) {
        return setting.time + 120
    }
    if (parseInt(setting.temperature, 10) < 10) {
        return setting.time + 120;
    }
    if (parseInt(setting.temperature, 10) >= 10 && parseInt(setting.temperature, 10) <= 30) {
        return (setting.time + 120) + ((setting.time + 120) % 300 !== 0 ? (300 - (setting.time + 120) % 300) : 0);
    }
    if (parseInt(setting.temperature, 10) >= 30) {
        if (setting.time < 600) {
            return (setting.time + 120) + ((setting.time + 120) % 300 !== 0 ? (300 - (setting.time + 120) % 300) : 0);
        }
    }
    return setting.time + (setting.time / 2) + ((setting.time + (setting.time / 2)) % 300 !== 0 ? (300 - (setting.time + (setting.time / 2)) % 300) : 0);
}

export const useCalculateTotalTime = (settings: any) => {
    const totalTime = useMemo(() => {
        let tatFlag = true;
        return settings.reduce((prev: number, setting: any, index: number) => {
            if ([HeatingModeEnum.TAT, HeatingModeEnum.RICECOOKER].includes(setting.heatingMode) && parseInt(setting.temperature, 10) > 20 && tatFlag) {
                tatFlag = false;
                return prev + approxTimeHandlerFunction(setting);
            }
            return prev + setting.time;
        }, 0)
    }, [settings])
    return totalTime
}

export const isCurrentInstructionTAT = (instruction: any) => ([HeatingModeEnum.TAT, HeatingModeEnum.RICECOOKER].includes(instruction?.heatingMode) && parseInt(instruction?.temperature, 10) > 20);

export function useTATTimeLogic({ setting }: { setting: settingsInterface }) {

    const resultTime = useMemo(() => approxTimeHandlerFunction(setting)
        , [setting]);

    return resultTime
}